
import { css } from 'lit';
export default css`
/* Apply CSS Variables to the host element. */
:host{
  --sic-carousel-block--default--font-size:var(--body-04-font-size);
  --sic-carousel-block--default--line-height:var(--body-04-line-height);
  --sic-carousel-block--default--layout-gap:var(--grid-gap);
}
`;